module.exports = __webpack_public_path__ + "static/media/view3.5f1e841a.jpg";